export class SharingDisplayPasswordItem {
    id: number;
    name: string;
    website: string;
    faviconUrl: string;
    checked: boolean = false;
    action: string = "";
}